import Home from './components/Home'
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import Coupon from './components/Coupon'

import './App.css'
import 'react-toastify/dist/ReactToastify.css'

function App() {
	return (
		<div className=" w-full ">
			<Router>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/:coupon" element={<Coupon />} />
				</Routes>
			</Router>
			<ToastContainer />
		</div>
	)
}

export default App
